import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
}

export interface IListSearchQueryPaginationPayload {
    pagination?: PaginationType
    textSearch?: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const companyListSlice = createSlice({
    name: 'hub/quotations/companyList',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onRequestFilter(state, action) {
            state.status = STATUS.RUNNING
        },
        onSuccessFilter(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onRequestSearch(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccessSearch(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailureSearch(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const companyListActions = companyListSlice.actions
export default companyListSlice.reducer
